<!--
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2024-01-18 10:02:24
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-19 14:30:04
 * @FilePath: \合联\oms\src\view\analysis\timeoutOrder\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/timeoutOrder";
export default {
  name: "timeoutOrder",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "dataType",
            placeholder() {
              return this.$tz("日期,类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "TIMEOUT_ORDER_SELECT"
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "from_country",
            placeholder() {
              return this.$tz("起运国");
            },
            component: "Select",
            options: [],
            optionsFn: "formCountry",
            optionsKey: ""
          },
          {
            key: "to_country",
            placeholder() {
              return this.$tz("目的国");
            },
            component: "Select",
            options: [],
            optionsFn: "toCountry",
            optionsKey: ""
          },
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户名称");
            },
            component: "Select",
            options: [],
            optionsFn: "customer",
            optionsKey: ""
          },
          {
            key: "delivery_agent",
            placeholder() {
              return this.$tz("地派");
            },
            component: "Select",
            options: [],
            optionsFn: "agent",
            optionsKey: ""
          },
          {
            key: "timeout_type",
            placeholder() {
              return this.$tz("异常,原因");
            },
            component: "Select",
            options: [],
            optionsFn: "timeoutType",
            optionsKey: ""
          },
          {
            key: "customer_service",
            placeholder() {
              return this.$tz("客服");
            },
            component: "Select",
            options: [],
            optionsFn: "service",
            optionsKey: "",
            apiData: [1]
          },
          {
            key: "status",
            placeholder() {
              return this.$tz("状态");
            },
            component: "Select",
            options: [
              {
                label: this.$tz("未处理"),
                value: 1
              },
              {
                label: this.$tz("已处理"),
                value: 2
              }
            ],
            optionsFn: "",
            optionsKey: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              disabled() {
                return this.selectAll.length === 0;
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center"
        },
        {
          name: () => this.$tz("订单号"),
          key: "airway_number",
          copy: true,
          header: {
            copy: true
          },
          minWidth: 130
        },
        {
          name: () => this.$tz("轨迹"),
          key: "status",
          minWidth: 110
        },
        {
          name: () => this.$tz("轨迹时间"),
          key: "status_time",
          minWidth: 160
        },
        {
          name: () => this.$tz("轨迹,描述"),
          key: "status_remarks",
          minWidth: 130
        },
        {
          name: () => this.$tz("地派"),
          key: "delivery_agent",
          minWidth: 130
        },
        {
          name: () => this.$tz("起运国"),
          key: "from_country",
          minWidth: 130
        },
        {
          name: () => this.$tz("目的国"),
          key: "to_country",
          minWidth: 130
        },
        {
          name: () => this.$tz("城市"),
          key: "city",
          minWidth: 130
        },
        {
          name: () => this.$tz("异常,原因"),
          key: "timeout_type",
          minWidth: 130
        },
        {
          name: () => this.$tz("客户名称"),
          key: "client",
          minWidth: 130
        },
        {
          name: () => this.$tz("客服名称"),
          key: "customer_service",
          minWidth: 130
        },
        {
          name: () => this.$tz("异常时间"),
          key: "create_time",
          minWidth: 160
        },
        {
          name: () => this.$tz("完结时间"),
          key: "complete_time",
          minWidth: 160
        }
      ]
    };
  }
};
</script>

<style scoped></style>
